import React, { useState } from 'react';
import { connect } from 'react-redux';
import { TextInput, Modal, Text, Bubble } from '@simplybenefits/sb-ui-library';
import { saveAgentBenefitAssignments } from '../../../actions/adjudication.js';
import permissionLevel from '../../../services/permissions.js';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const AgentBenefitAssignment = ({ 
    close,
    loader,
    dispatch,
    open,
    adjudicators,
    agentBenefitsList,
    accessType
}) => {
    const [ agent, setAgent ] = useState({
        agentId: null,
        benefits: []
    });

    /**
     * 
     * @param {*} e 
     */
    const _handleAgentChange = (e) => {
        const selectedAgentId = Object.keys(agentBenefitsList).find((masterID) => `${ agentBenefitsList[masterID].meta.firstname } ${ agentBenefitsList[masterID].meta.lastname }` === e.target.value);

        setAgent({
            agentId: selectedAgentId,
            benefits: agentBenefitsList[selectedAgentId]?.benefits
        });
    };

    /**
     * 
     */
    const _assignBenefits = async () => {
        if (!permissionLevel('Assign Agent Benefits', accessType).includes('write')) {
            return;
        }

        const success = await dispatch(saveAgentBenefitAssignments(agent.agentId, agent.benefits));

        if (success) {
            close();
        }
    };

    /**
     * 
     * @param {*} benefit 
     */
    const _toggleBenefit = (benefit) => {
        const isSelected = agent.benefits.find((item) => item === benefit);

        if (isSelected) {
            setAgent((prevState) => ({
                ...prevState,
                benefits: agent.benefits.filter((item) => item !== benefit)
            }));
        } else {
            setAgent((prevState) => ({
                ...prevState,
                benefits: [ ...agent.benefits, benefit ]
            }));
        }
    };
    
    return (
        <Modal
            medium
            open={open}
            onClose={close}
            title="Set Adjudicator Benefits"
            loader={loader}
            primaryButton={{
                label: "Assign Benefits",
                onClick: _assignBenefits  
            }}
        >
            <Text
                align="left"
                medium
                display="inline-block"
                margin="10px 0"
            >
                    Assign which benefits each adjudication agent has access to. The system will only auto assign claims that match the selected benefits. Select an adjudicator below to get started.
            </Text>

            <TextInput
                label="Adjudicator"
                fullWidth
                value={
                    agent.agentId ?
                        `${ agentBenefitsList[agent.agentId].meta.firstname } ${ agentBenefitsList[agent.agentId].meta.lastname }`
                        :
                        'Please select an agent'
                }
                onChange={(e) => _handleAgentChange(e)}
                select
                selectOptions={ adjudicators }
            />

            {
                agent.agentId ?
                    <div style={{ display: 'flex', flex: 1, flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'space-around' }}>
                        <Bubble
                            label="Drugs"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Drugs") }
                            onClick={ () => _toggleBenefit("Drugs")}
                        />

                        <Bubble
                            label="Dental"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Dental") }
                            onClick={ () => _toggleBenefit("Dental")}
                        />

                        <Bubble
                            label="Health (Major)"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Health") }
                            onClick={ () => _toggleBenefit("Health")}
                        />

                        <Bubble
                            label="Paramedicals"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Paramedicals") }
                            onClick={ () => _toggleBenefit("Paramedicals")}
                        />

                        <Bubble
                            label="Vision"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Vision") }
                            onClick={ () => _toggleBenefit("Vision")}
                        />

                        <Bubble
                            label="Cost Plus"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Cost Plus") }
                            onClick={ () => _toggleBenefit("Cost Plus")}
                        />

                        <Bubble
                            label="Spending Account"
                            clickable={ true }
                            isSelected={ agent.benefits.find((item) => item === "Spending Account") }
                            onClick={ () => _toggleBenefit("Spending Account")}
                        />
                    </div>
                    :
                    null
            }
        </Modal>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accessType: state.master.access
});

export default connect(mapStateToProps)(AgentBenefitAssignment);